import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import React from 'react'
import type {FunctionComponent, HTMLAttributes} from 'react'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

export interface DiscountBadgeProps extends HTMLAttributes<HTMLDivElement> {
  discount?: number
  source?: string
}

export const DiscountBadgeReorganized: FunctionComponent<DiscountBadgeProps> = ({discount, source, ...props}) => {
  const {locale, language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  return (
    <div {...props}>
      <p
        className={clsx('text-sm font-light lowercase', locale.toLowerCase() === 'de' && 'mobile:before:content-["-"]')}
      >
        {translations.Badge.discountAmount(discount)}
        <em className={clsx('ml-1 not-italic', locale.toLowerCase() === 'de' && 'mobile:hidden')}>
          {translations.Badge.off}
        </em>
      </p>
    </div>
  )
}
